import React, { useEffect, useState, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  fetchRateAdminRateCode,
  initializeRateAdminRateCodeScreen,
  setDeleteConfirmationPopupVisibility,
  exportRateAdminRateCode,
  deleteRateAdminRateCode,
  saveRateCodeTableState
} from "../../../redux/actions/RateAdmin/rateadminRateCode";
import RateAdminRateCode from '../../../component/RateAdmin/RateAdminRateCode';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
import { FILTER } from '../../../services/common/urlService';
import { DATE_STRATEGY, formatDate } from '../../../utils/date';
function RateAdminRateCodeScreen(props) {
  const {
    fetchRateAdminRateCode,
    initRateAdminRateCodeScreen,
    showPageLevelLoader,
    rateAdminRateCodeListview,
    paginationInfo,
    screenPermissions,
    exportRateAdminRateCode,
    isRateAdminRateCodeExportError,
    isRateAdminRateCodeExportSuccess,
    isLoading,
    deleteRateAdminRateCode,
    isRateAdminRateCodeDeleteSuccess,
    isRateAdminRateCodeDeleteError,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    savedTableState,
    saveRateCodeTableState,
  } = props;
  const navigate = useNavigate();
  
  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initRateAdminRateCodeScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchRateAdminRateCode(savedParams);
    } else {
      fetchRateAdminRateCode({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchRateAdminRateCode(props);
  };
  
  // Callback to save raw table state for restoration after navigation
  const handleTableStateChange = (rawParams) => {
    saveRateCodeTableState(rawParams);
  };
  const handleCreateRateAdminRateCode = () => {
    navigate(APP_URLS.RATEADMIN_RATE_CODE.CREATE);
  }
  const editRateAdminRateCodeRoute = (id) => {
    const path = generatePath(APP_URLS.RATEADMIN_RATE_CODE.EDIT, {
      id,
    });
    navigate(path);
  };
  const rateAdminRateCode = {
    handleCreateRateAdminRateCode,
    exportRateAdminRateCode,
    isRateAdminRateCodeExportError,
    isRateAdminRateCodeExportSuccess,
    editRateAdminRateCodeRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    deleteRateAdminRateCode,
    isRateAdminRateCodeDeleteSuccess,
    isRateAdminRateCodeDeleteError,
    fetchRateAdminRateCodes: loadLazyData,
    savedTableState,
    onTableStateChange: handleTableStateChange,
    tableData: {
      columns: rateAdminRateCodeListview?.columns,
      rows: rateAdminRateCodeListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <RateAdminRateCode
        {...rateAdminRateCode}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initRateAdminRateCodeScreen: () => dispatch(initializeRateAdminRateCodeScreen()),
    fetchRateAdminRateCode: (payload) => dispatch(fetchRateAdminRateCode(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportRateAdminRateCode: (payload) => dispatch(exportRateAdminRateCode(payload)),
    deleteRateAdminRateCode: (payload) => dispatch(deleteRateAdminRateCode(payload)),
    saveRateCodeTableState: (payload) => dispatch(saveRateCodeTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isRateAdminRateCodeCreateSuccess: selectFromRateAdminRateCodeReducer(
      state,
      "isRateAdminRateCodeCreateSuccess"
    ),
    rateAdminRateCodeListview: selectFromRateAdminRateCodeReducer(
      state,
      "rateAdminRateCodeListview"
    ),
    showPageLevelLoader: selectFromRateAdminRateCodeReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromRateAdminRateCodeReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromRateAdminRateCodeReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromRateAdminRateCodeReducer(
      state,
      "isFetchingGridData"
    ),
    isLoading: selectFromRateAdminRateCodeReducer(
      state,
      "isLoading"
    ),
    isRateAdminRateCodeExportError: selectFromRateAdminRateCodeReducer(
      state,
      "isRateAdminRateCodeExportError"
    ),
    isRateAdminRateCodeExportSuccess: selectFromRateAdminRateCodeReducer(
      state,
      "isRateAdminRateCodeExportSuccess"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromRateAdminRateCodeReducer(
      state,
      "shouldOpenDeleteConfirmationPopup"
    ),
    isRateAdminRateCodeDeleteSuccess: selectFromRateAdminRateCodeReducer(
      state,
      "isRateAdminRateCodeDeleteSuccess"
    ),
    isRateAdminRateCodeDeleteError: selectFromRateAdminRateCodeReducer(
      state,
      "isRateAdminRateCodeDeleteError"
    ),
    savedTableState: selectFromRateAdminRateCodeReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromRateAdminRateCodeReducer = (state, path) => {
  return selectRateAdminRateCodeReducer(state)[path];
};

const selectRateAdminRateCodeReducer = ({ rateadminRateCodeReducer }) => {
  return rateadminRateCodeReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(RateAdminRateCodeScreen);
